import React, { createContext, useContext, useState } from "react";

/**
 * PageHeaderTrailContext — Round 22 (owner feedback).
 *
 * The page banner (DashboardPageHeader) publishes its title + breadcrumb
 * trail here; the fixed topbar (Layouts/Header.js) renders it. Result:
 * the page name and its clickable trail stay visible while the page
 * scrolls — on every module and sub-page, automatically — instead of
 * scrolling away with the in-page banner.
 *
 * Pages render banners exactly as before; no per-page wiring needed.
 * Pages without a banner simply leave the topbar slot empty.
 */
const PageHeaderTrailContext = createContext({ trail: null, setTrail: () => {} });

export const PageHeaderTrailProvider = ({ children }) => {
    const [trail, setTrail] = useState(null); // { title, crumbs: [{label, to?, onClick?}] }
    return (
        <PageHeaderTrailContext.Provider value={{ trail, setTrail }}>
            {children}
        </PageHeaderTrailContext.Provider>
    );
};

export const usePageHeaderTrail = () => useContext(PageHeaderTrailContext);

export default PageHeaderTrailContext;
